import { createAction } from 'redux-actions'

import {
  SIMS_FETCH,
  CURRENT_SIM_FETCH,
  SIM_UPDATE,
  SIM_INFO_UPDATE,
  SIMS_RECEIVE,
  UPDATE_ORDER,
  UPDATE_ORDER_FINISHED,
  CURRENT_ORDER_FETCH,
  CURRENT_ORDER_RECEIVE,
  CURRENT_SIM_RECEIVE,
  CURRENT_SIM_CLEAR,
  CURRENT_SIM_POLL,
  NON_ACTIVATED_SIMS_FETCH,
  NON_ACTIVATED_SIMS_RECEIVE,
} from './constants'

export const fetchSims = createAction(SIMS_FETCH, (id) => ({
  id,
}));

export const updateSim = createAction(SIM_UPDATE, (id, data, options = {}) => ({
  id,
  data,
  options,
}));

export const updateSimInfo = createAction(SIM_INFO_UPDATE, (id, data) => ({
  id,
  data,
}));

export const receiveSims = createAction(SIMS_RECEIVE, (entities, result) => ({
  entities,
  result,
}));

export const updateOrder = createAction(UPDATE_ORDER);

export const updateOrderFinished = createAction(UPDATE_ORDER_FINISHED);

export const fetchCurrentOrder = createAction(CURRENT_ORDER_FETCH, (order) => ({
  order,
}));

export const receiveCurrentOrder = createAction(CURRENT_ORDER_RECEIVE, (order) => ({
  order,
}));

export const fetchCurrentSim = createAction(CURRENT_SIM_FETCH, (id) => ({
  id,
}));

export const receiveCurrentSim = createAction(CURRENT_SIM_RECEIVE, (currentSim) => ({
  currentSim,
}));

export const clearCurrentSim = createAction(CURRENT_SIM_CLEAR);

export const pollCurrentSim = createAction(CURRENT_SIM_POLL, (id) => ({
  id,
}));

export const fetchNonActivatedSims = createAction(NON_ACTIVATED_SIMS_FETCH, (id) => ({
  id,
}));

export const receiveNonActivatedSims = createAction(NON_ACTIVATED_SIMS_RECEIVE, (nonActivatedSims) => ({
  nonActivatedSims,
}));